import React from 'react';
import { FormInstance } from 'antd';
import {
  Input,
  Modal,
  Select,
} from 'UI';
import { UnitEnum, UnitMapping } from 'constants/unit';
import {
  ResourceCategoryEnum,
  ResourceCategoryMapping,
  ResourceCostAccountEnum,
  ResourceCostAccountMapping,
} from 'constants/resource';

import {
  FormContainer,
  BaseFormItem,
  InlineButton,
} from './style';

export interface ResourceFormData {
  name: string
  unit: UnitEnum
  category: ResourceCategoryEnum
  costAccount: ResourceCostAccountEnum
}

interface ResourceModalProps {
  formHandler: FormInstance
  onSubmit(data: unknown): void
  onCancel(): void
  curResource?: ResourceFormData
  isLoading: boolean
  isVisible: boolean
}

const ResourceModal = ({
  formHandler,
  onSubmit,
  onCancel,
  curResource,
  isLoading,
  isVisible,
}: ResourceModalProps): JSX.Element => (
  <Modal
    visible={isVisible}
    title={curResource ? 'Editar' : 'Novo'}
    destroyOnClose
    onCancel={onCancel}
    afterClose={onCancel}
    zIndex={90}
    footer={[
      <InlineButton
        key="cancel"
        onClick={onCancel}
        type="ghost"
      >
        Cancelar
      </InlineButton>,
      <InlineButton
        key="submit"
        onClick={onSubmit}
        disabled={isLoading}
        loading={isLoading}
      >
        Salvar
      </InlineButton>,
    ]}
  >
    <FormContainer
      layout="vertical"
      form={formHandler}
      requiredMark={false}
      onFinish={onSubmit as (val: unknown) => void}
    >
      <BaseFormItem
        label="Item"
        name="name"
        rules={[
          {
            required: true,
            message: 'Insira um nome para o item',
          },
        ]}
        initialValue={curResource?.name}
      >
        <Input disabled={isLoading} />
      </BaseFormItem>
      <BaseFormItem
        label="Unidade"
        name="unit"
        rules={[
          {
            required: true,
            message: 'Selecione uma unidade de medida',
          },
        ]}
        initialValue={curResource?.unit || UnitEnum.GRAM}
      >
        <Select
          disabled={isLoading}
          className="unit-input"
        >
          {Object.values(UnitEnum).map((val) => (
            <Select.Option value={val} key={val}>
              {UnitMapping[val].name}
            </Select.Option>
          ))}
        </Select>
      </BaseFormItem>
      <BaseFormItem
        label="Categoria"
        name="category"
        rules={[
          {
            required: true,
            message: 'Selecione uma categoria',
          },
        ]}
        initialValue={curResource?.category || ResourceCategoryEnum.SEEDING}
      >
        <Select
          disabled={isLoading}
          className="category-input"
        >
          {Object.values(ResourceCategoryEnum).map((val) => (
            <Select.Option value={val} key={val}>
              {ResourceCategoryMapping[val].name}
            </Select.Option>
          ))}
        </Select>
      </BaseFormItem>
      <BaseFormItem
        label="Conta de Custo"
        name="costAccount"
        rules={[
          {
            required: true,
            message: 'Selecione uma conta de custo',
          },
        ]}
        initialValue={curResource?.costAccount || ResourceCostAccountEnum.TRAY}
      >
        <Select
          disabled={isLoading}
          className="cost-account-input"
        >
          {Object.values(ResourceCostAccountEnum).map((val) => (
            <Select.Option value={val} key={val}>
              {ResourceCostAccountMapping[val].name}
            </Select.Option>
          ))}
        </Select>
      </BaseFormItem>
    </FormContainer>
  </Modal>
);

ResourceModal.defaultProps = {
  curResource: undefined,
};

export default ResourceModal;
